// import PerfectScrollbar from "perfect-scrollbar";

const PerfectScrollbarPlugin = {
  install(Vue) {
    let parent = null;

    Vue.directive("scrollbar", {
      bind: (el, _bind, vnode) => {
        vnode.context.$root.$nextTick(() => {
          parent = el;

          el.id = "_scroll-parent";
          // new PerfectScrollbar(el);
        });
      }
    });

    const scrollTo = child => {
      if (!parent || !child) {
        return;
      }

      const parentScroll = parent.scrollTop;
      const parentRect = parent.getBoundingClientRect();
      const childRect = child.getBoundingClientRect();
      if (!parentRect || !childRect) {
        return;
      }

      const childPos = childRect.top - parentRect.top + parentScroll;
      parent.scrollTo({
        top: childPos,
        left: 0,
        behavior: "smooth"
      });
    };

    const scrollToImmidiate = child => {
      if (!parent || !child) {
        return;
      }

      const parentScroll = parent.scrollTop;
      const parentRect = parent.getBoundingClientRect();
      const childRect = child.getBoundingClientRect();
      if (!parentRect || !childRect) {
        return;
      }

      const childPos = childRect.top - parentRect.top + parentScroll;
      parent.scrollTo({
        top: childPos,
        left: 0
      });
    };

    const scrollToSelector = (selector, immediate = false) => {
      const target = document.querySelector(selector);
      if (!target) {
        return;
      }

      if (immediate) {
        scrollToImmidiate(target);
      } else {
        scrollTo(target);
      }
    };

    const scrollToTop = () => {
      if (!parent) {
        return;
      }

      parent.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    };

    const scrollToTopImmidiate = () => {
      if (!parent) {
        return;
      }

      parent.scrollTo({
        top: 0,
        left: 0
      });
    };

    Vue.prototype.$perfectScrollbar = {
      scrollTo,
      scrollToImmidiate,
      scrollToSelector,
      scrollToTop,
      scrollToTopImmidiate
    };
  }
};

export default PerfectScrollbarPlugin;
